import React from 'react';
import mixpanel from 'mixpanel-browser';
import { v4 as uuidv4 } from 'uuid';
import NavBar from '../NavBar';
import { FaqSection } from './FaqSection';
import { Footer } from './Footer';
import { faqList } from '../../constants/Footer/faq';
import './Faq.css';

export const FAQ = () => {
  mixpanel.track('FAQ page', {
    path: '/faq',
  });
  return (
    <>
      <NavBar currentPath="faq" />
      <div className="faqContainer">
        <div className="header">
          <h1 className="faqTitle">Frequently Asked Questions</h1>
          <p className="faqSubtitle">Find Answers For Common Questions</p>
        </div>
        <div className="faqSections">
          {faqList.map((section) => (
            <FaqSection key={uuidv4()} sectionTitle={section.title} questions={section.questions} />
          ))}
        </div>
      </div>
      <Footer currentPath={'/faq'} />
    </>
  );
};
